import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { isAnyPresent } from '@shared/utils/helpers';

@Pipe({ name: 'isAnyPresent' })
export class IsAnyPresentPipe implements PipeTransform {
    transform(value: any | any[]): any {
        if (Array.isArray(value)) {
            return isAnyPresent(...value);
        }

        return isAnyPresent(value);
    }
}
